import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-whatsapp-message',
  templateUrl: './whatsapp-message.component.html',
  styleUrls: ['./whatsapp-message.component.scss']
})
export class WhatsappMessageComponent implements OnInit {
  @Input() mobile: string;
  @Input() text: string;
  @Input() label: string;

  constructor(private sanitizer:DomSanitizer) { }

  ngOnInit(): void {
  }

  get url() {
    let url = `https://wa.me/98${this.mobile}?text=${encodeURIComponent(this.text)}`;

    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

}
